var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHorizontalMenuOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu 2",
    clipPath: "url(#clip0_10277_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.94178V10.2168L2.26066 10.212L4.52133 10.2072V7.94178V5.67638L2.26066 5.67156L0 5.66675V7.94178ZM5.7339 5.69052C5.72891 5.7036 5.72703 6.72519 5.72973 7.96074L5.7346 10.2072H8H10.2654V7.94178V5.67638L8.00417 5.67156C6.20518 5.66773 5.7411 5.6716 5.7339 5.69052ZM11.4779 5.6906C11.473 5.70364 11.4711 6.72519 11.4738 7.96074L11.4787 10.2072L13.7393 10.212L16 10.2168V7.94186V5.6669H13.7435C11.9557 5.6669 11.4851 5.67183 11.4779 5.6906ZM1.19431 7.94178V9.00339H2.2654H3.33649V7.94178V6.88017H2.2654H1.19431V7.94178ZM6.93839 7.94178V9.00339H8H9.06161V7.94178V6.88017H8H6.93839V7.94178ZM12.6635 7.94178V9.00339H13.7346H14.8057V7.94178V6.88017H13.7346H12.6635V7.94178Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10277_5704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHorizontalMenuOutline);
export default __webpack_public_path__ + "static/media/icon--horizontal-menu-outline.c2cfd5c416df46db2693c0a14f2d660c.svg";
export { ForwardRef as ReactComponent };